import { Box, CardMedia, Typography } from "@mui/material";
import { Link } from "react-router-dom";

export default function ContactItem({ item }) {
  return (
    <Link to={item.link} target="_blank" style={{ textDecoration: "none" }}>
      <Box sx={{ display: "flex", alignItems: "center", marginLeft: -2 }}>
        <Box sx={{ height: 64, marginBottom: -1.2 }}>
          <CardMedia height="100%" component="img" src={item.icon} />
        </Box>
        <Typography
          variant="p"
          sx={{
            flex: 1,
            fontFamily: "Poppins",
            fontWeight: 500,
            fontSize: { xs: 14, md: 16 },
            color: "black",
            textShadow: "0px 4px 4px rgba(255, 255, 255, 0.25)",
          }}
        >
          {item.text}
        </Typography>
      </Box>
    </Link>
  );
}
